import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import Random from "../../utils/strings/Random";
import DatePicker from "../../components/form/DatePicker";
import moment from 'moment';
import PAGES from '../../config/Pages';
import Modal from '../../components/modal.v2/Modal';

const URL_SAVE = WS.medidas.save;

export default class Detail extends React.Component {
  constructor(props){
    super(props);

    const data = props.data ? props.data : {};

    this.state = {
      wrapper:Random(7),
      strings:STRINGS[window.LANGUAGE],
      id: data.id,
      peso: data.peso || '',
    	altura: data.altura || '',
    	gordura_corporal: data.gordura_corporal || '',
    	biceps_direito: data.biceps_direito || '',
    	biceps_esquerdo: data.biceps_esquerdo || '',
    	antebraco_direito: data.antebraco_direito || '',
    	antebraco_esquerdo: data.antebraco_esquerdo || '',
    	coxa_direita:data.coxa_direita || '',
    	coxa_esquerda: data.coxa_esquerda || '',
    	panturrilha_direita: data.panturrilha_direita || '',
    	panturrilha_esquerda: data.panturrilha_esquerda || '',
    	torax: data.torax || '',
    	cintura: data.cintura || '',
    	abdomen: data.abdomen || '',
    	quadril: data.quadril || '',
      data: data.data ? data.data : moment().format("DD/MM/YYYY")
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeDate = this.changeDate.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);

  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });

  }

  changeDate(date) {
    this.setState({
      data: moment(date).format("DD/MM/YYYY")
    });
  }

  handleSubmit (e){
    e.preventDefault();

    const _self = this;
    const {
      atencao,
      salvoSucesso,
      erroSalvarBloco,
      preenchaCamposAsterisco,
      erroSalvar,
      periodoGratuitoMsg
    }
    = this.state.strings;

    var object = {...this.state};
    delete object.strings;

    if(object.peso === '' || object.data === ''){
      let msg = {
        title: atencao,
        text:preenchaCamposAsterisco
      };
      Dialog.create(msg);
      return false;
    }

    const history = this.props.history;

    //----------------
    const msg = {
      title: atencao,
      text: periodoGratuitoMsg
    };
    Dialog.create(msg);
    Modal.destroy();
    history.push(PAGES.medidas);

    /*Requisitions({
      url: URL_SAVE,
      data: object,
      sucess:function(data){
        var msg;
        Modal.destroy();
        history.push(PAGES.medidas);
        msg = {
          title: atencao,
          text: data.msg
        };
        Dialog.create(msg);
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroSalvar
        });
      }
    });*/
  }

  render(){
    const data = this.props.data;
    const str = this.state.strings;

    return(
      <div>
        <MainTitle title="Minhas medidas"></MainTitle>
        <div>
          <form id={this.state.wrapper} onSubmit={this.handleSubmit} className="pure-g">
            <input type='hidden' name='id' value={this.state.id} />
            <div className="pure-u-1 pure-u-md-1-3">
              <DatePicker
                name='data'
                value={this.state.data}
                title={str.txtData}
                handleChange={this.changeDate}
              />
            </div>
            <div className="pure-u-1"></div>
            <div className="pure-u-1 pure-u-md-1-3">
              <TextInput
                value={this.state.peso}
                name="peso"
                inputMask={{
                  name:'peso',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                type='number'
                maxlength="4"
                title={`${str.fieldPeso}*`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-3">
              <TextInput
                value={this.state.altura}
                name="altura"
                inputMask={{
                  name:'altura',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                type='number'
                maxlength="4"
                title={`${str.fieldAltura}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-3">
              <TextInput
                value={this.state.gordura_corporal}
                name="gordura_corporal"
                type='number'
                inputMask={{
                  name:'gordura_corporal',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                maxlength="4"
                title={`${str.fieldGordura}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className='separator'></div>
            <div className="pure-u-1 pure-u-md-1-4">
              <TextInput
                value={this.state.biceps_direito}
                name="biceps_direito"
                type='number'
                inputMask={{
                  name:'biceps_direito',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                maxlength="4"
                title={`${str.fieldBicepsDireito}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-4">
              <TextInput
                value={this.state.biceps_esquerdo}
                name="biceps_esquerdo"
                type='number'
                inputMask={{
                  name:'biceps_esquerdo',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                maxlength="4"
                title={`${str.fieldBicepsEsquerdo}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-4">
              <TextInput
                value={this.state.antebraco_direito}
                name="antebraco_direito"
                type='number'
                maxlength="4"
                inputMask={{
                  name:'antebraco_direito',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                title={`${str.fieldAntebracoDireito}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-4">
              <TextInput
                value={this.state.antebraco_esquerdo}
                name="antebraco_esquerdo"
                type='number'
                maxlength="4"
                inputMask={{
                  name:'antebraco_esquerdo',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                title={`${str.fieldAnterabracoEsq}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-4">
              <TextInput
                value={this.state.coxa_direita}
                name="coxa_direita"
                type='number'
                maxlength="4"
                inputMask={{
                  name:'coxa_direita',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                title={`${str.fieldCoxaDireita}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-4">
              <TextInput
                value={this.state.coxa_esquerda}
                name="coxa_esquerda"
                type='number'
                inputMask={{
                  name:'coxa_esquerda',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                maxlength="4"
                title={`${str.fieldCoxaEsquerda}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-4">
              <TextInput
                inputMask={{
                  name:'panturrilha_direita',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                value={this.state.panturrilha_direita}
                name="panturrilha_direita"
                type='number'
                maxlength="4"
                title={`${str.fieldPanturrilhaDireita}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-4">
              <TextInput
                value={this.state.panturrilha_esquerda}
                name="panturrilha_esquerda"
                type='number'
                maxlength="4"
                inputMask={{
                  name:'panturrilha_esquerda',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                title={`${str.fieldPanturrilhaEsquerda}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-4">
              <TextInput
                value={this.state.torax}
                name="torax"
                type='number'
                maxlength="4"
                inputMask={{
                  name:'torax',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                title={`${str.fieldTorax}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-4">
              <TextInput
                value={this.state.cintura}
                name="cintura"
                type='number'
                maxlength="4"
                inputMask={{
                  name:'cintura',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                title={`${str.fieldCintura}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-4">
              <TextInput
                value={this.state.abdomen}
                name="abdomen"
                type='number'
                maxlength="4"
                inputMask={{
                  name:'abdomen',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                title={`${str.fieldAbdomen}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-4">
              <TextInput
                value={this.state.quadril}
                name="quadril"
                type='number'
                maxlength="4"
                inputMask={{
                  name:'quadril',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                title={`${str.fieldQuadril}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className='campos-obrigatorios pure-u-1'>Campos obrigatórios *</div>
            <div className='separator'></div>
            <div className="box-right-button pure-u-1"><Button type="submit" text={str.salvar} classes="bt-save bt-blue" /></div>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/medidas/Detail.js